import React from "react";
import "../styles/Home.scss";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const Home = () => {
  return (
    <section className="home">
      <div className="home-content">
        <h1>
          Welcome to <img src={logo} alt="ErosModel" className="inline-logo" />
        </h1>
        <p className="cta">Join us. Elevate your presence. Redefine beauty.</p>
        <Link to="/get-scouted" className="scout-button">
          Get Scouted
        </Link>
      </div>
    </section>
  );
};

export default Home;
